export default __webpack_public_path__ + "static/media/cryptoAnalysis.0fb438db.jpg";